import { render, staticRenderFns } from "./point-shield-rule.vue?vue&type=template&id=2e08d88c&scoped=true"
import script from "./point-shield-rule.vue?vue&type=script&lang=js"
export * from "./point-shield-rule.vue?vue&type=script&lang=js"
import style0 from "./point-shield-rule.vue?vue&type=style&index=0&id=2e08d88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08d88c",
  null
  
)

export default component.exports